import ApiClient from ".."
import { EventTypeKey } from "../../constants/eventTypes"
import EventPostIn from "../../dtos/in/EventPostIn"

// TYPES

// In DTOs

// Out DTOs
import GenericOut from "../../dtos/out/GenericOut"

export class EventEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/event"

  /**
   * Posts a new event.
   *
   * - Will retry on failure with default retry configuration.
   */
  async postEvent(eventKey: EventTypeKey, metadata?: Record<string, any>): Promise<GenericOut> {
    const payload: EventPostIn = {
      eventKey,
      occurredAt: new Date(),
      metadata
    }
    return this.client.post<GenericOut>(EventEndpoints.BASE_URL, "/", payload, {}, ApiClient.retryConfig.default())
  }
}
